// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function isBooleanOrUndefined(value: any) {
  if (typeof value === "undefined" || typeof value === "boolean") {
    return true;
  }
  return false;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function booleanToNumericString(value: boolean) {
  return value ? "1" : "0";
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function anyToBoolean(value: any) {
  if (typeof value === "string") {
    return value.length !== 0 && value !== "0" && value.toLocaleLowerCase() !== "false";
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return value !== null && !(Object.keys(value).length === 0 && value.constructor === Object);
  }

  return !!value;
}

export function stringToBoolean(text: string | boolean): boolean {
  return text === true || text === "true" || !!parseInt(String(text), 2);
}
